import React, { useState, useEffect } from "react";
import Socket from "socket";
import { connect } from "react-redux";
import _ from "lodash";

const PresenterJoining = (props) => {
  const joining_data = _.get(props, "paramsReducer.gameObj.joining");
  const presenter_title = _.get(joining_data, "presenter_title", "Presenter");
  const room_obj = _.get(props, "gameReducer.roomObj");
  const slidekick_only = _.get(room_obj, "game_state.slidekick_only");
  const slidekick_status = _.get(room_obj, "game_state.slidekick_status");
  const hero_status = _.get(room_obj, "game_state.hero_status");
  const presenter_instructions = _.get(
    joining_data,
    "presenter_instructions",
    "Instructions"
  );
  const presenter_top = _.get(
    joining_data,
    "presenter_top",
    "Put in the Hero/SlideKick slides on the tabletop and start the meeting."
  );
  const presenter_bottom = _.get(
    joining_data,
    "presenter_bottom",
    "You can start using the button below as well once your slides are ready to go!"
  );
  const [submit_btn_active, set_submit_btn_active] = useState(false);
  useEffect(() => {
    if (slidekick_only && slidekick_only === true) {
      if (slidekick_status && slidekick_status === "Good") {
        set_submit_btn_active(true);
      }
    } else {
      if (
        slidekick_status &&
        hero_status &&
        slidekick_status === "Good" &&
        hero_status === "Good"
      ) {
        set_submit_btn_active(true);
      }
    }
  }, [slidekick_status, hero_status]);

  const on_start = () => {
    let data = {
      action: "update-status",
      roomId: room_obj.id,
    };
    Socket.sendMessage(data);
  };

  return (
    <div className="presenter-joining-wrapper">
      <h1 className="heading">{presenter_title}</h1>
      <div className="instructions">
        <h2>{presenter_instructions}</h2>
        <p>{presenter_top}</p>
        <p>{presenter_bottom}</p>
      </div>
      <div className={submit_btn_active ? "start" : "disabled"}>
        <button
          disabled={!submit_btn_active}
          className="btn"
          onClick={() => on_start()}
        >
          <i className="fas fa-play"></i>
        </button>
        <h4>Start</h4>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(PresenterJoining);
